"use client"

import { useEffect } from "react"
import { useUser } from "@clerk/nextjs"
import Userback from "@userback/widget"

export function UserbackWidget() {
  const { user, isLoaded } = useUser()

  useEffect(() => {
    if (typeof window === "undefined" || !isLoaded) return

    // If user is logged out, hide Userback widget
    if (!user) {
      const userbackButton = document.querySelector('[data-userback-button]') as HTMLElement
      if (userbackButton) {
        userbackButton.style.display = 'none'
      }

      const userbackWidget = document.querySelector('#userback_button_container') as HTMLElement
      if (userbackWidget) {
        userbackWidget.style.display = 'none'
      }

      return
    }

    // Check cookie consent
    try {
      const consent = localStorage.getItem("cookie-consent")
      if (!consent) return

      const parsed = JSON.parse(consent)
      if (!parsed.analytics) return
    } catch {
      return
    }

    // Initialize Userback with user data
    const initUserback = async () => {
      const options = {
        user_data: {
          id: user.id,
          info: {
            name: `${user.firstName || ""} ${user.lastName || ""}`.trim() || "Anonymous",
            email: user.emailAddresses[0]?.emailAddress || "",
          },
        },
      }

      await Userback("A-3ueLs3lrSWFYoveOm1qHTo88P", options)

      // Show the widget button after initialization
      const userbackButton = document.querySelector('[data-userback-button]') as HTMLElement
      if (userbackButton) {
        userbackButton.style.display = ''
      }

      const userbackWidget = document.querySelector('#userback_button_container') as HTMLElement
      if (userbackWidget) {
        userbackWidget.style.display = ''
      }
    }

    initUserback()
  }, [user, isLoaded])

  return null
}
